import { render } from "./EditItemAdmin.vue?vue&type=template&id=3a3c4510"
import script from "./EditItemAdmin.vue?vue&type=script&lang=js"
export * from "./EditItemAdmin.vue?vue&type=script&lang=js"

import "./EditItemAdmin.vue?vue&type=style&index=0&id=3a3c4510&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__